import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";

export const Units = () => {
    document.title = "Ölçü vahidləri";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Parametrlər", value: "/products/parameters" },
        { name: "Ölçü vahidləri", value: "/products/parameters/search", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Ölçü vahidləri</h2>
                    <p>
                        Ölçü vahidi təyin etmək üçün <b>Ölçü vahidi</b> xanasında seçim edin. Yeni ölçü vahidi təyin etmək üçün nümumədəki ardıcıllığa baxın.
                    </p>
                    <img src="/images/products/parameters/units.gif" alt="Ölçü vahidləri" />
                </article>
            </div>
        </div>
    );
};
